import { createEmptyCollection, getItemFromCollection, setItemInCollection } from 'helpers/normalizeHelpers'
import { Collection, Reducer } from 'interfaces'
import { CreditCard, CCBase } from 'components/features/creditCard/creditCardStore/types'
import { CreditCardDataState } from 'components/features/creditCard/creditCardStore/state'
import { CCLockCardAction, CCReplaceCardAction, CCUnlockCardAction, GetCCStateAction } from 'components/features/creditCard/creditCardStore/actions'
import { captureWarning } from 'helpers/errorHelpers'
import { WsMessageAction } from 'actions/webSocketActions'

function updateCard (prevState: Collection<CreditCard, 'uid'>, nextCard: CCBase): Collection<CreditCard, 'uid'> {
  const prevCard = getItemFromCollection(prevState, nextCard.uid)
  if (!prevCard) {
    captureWarning('Credit card reducer can\'t update card on replace card API response')
    return prevState
  }
  const { ledgerUid } = prevCard

  return setItemInCollection(prevState, {
    ...nextCard,
    ledgerUid,
  }, 'uid')
}

const INITIAL_STATE = createEmptyCollection()
export const ccCardsReducer: Reducer<CreditCardDataState['cards']> = (prevState = INITIAL_STATE, action) => {
  switch (action.type) {
    case GetCCStateAction.type: {
      if (action.meta !== 'success') {
        return prevState
      }

      const { cards } = action.payload.response
      return cards
    }

    case CCLockCardAction.type:
    case CCUnlockCardAction.type:
    case CCReplaceCardAction.type: {
      if (action.meta !== 'success') {
        return prevState
      }

      const nextCard = action.payload.response
      return updateCard(prevState, nextCard)
    }

    case WsMessageAction.type: {
      if (action.payload.event !== 'credit_card_changed') {
        return prevState
      }

      const nextCard = action.payload.data.card
      return updateCard(prevState, nextCard)
    }
  }
  return prevState
}
